import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'percent' })
export class PercentPipe implements PipeTransform {
  transform(value: number): string {
    if (Number.isNaN(value) || !this.isNumeric(value)) {
      return '0%';
    }

    const isInteger = Number.isInteger(Math.round(value * 10) / 10)

    if (isInteger) {
      return `${Math.round(value * 10) / 10}.0%`
    } else {
      return `${Math.round(value * 10) / 10}%`;

    }
  }

  isNumeric(value): boolean {
    if (value < 0) value = value * -1;
    if (/^-{0,1}\d+$/.test(value)) {
      return true;
    } else if (/^\d+\.\d+$/.test(value)) {
      return true;
    } else {
      return false;
    }
  }
}
